import Document from "@tiptap/extension-document";
import { Attribute } from "@tiptap/react";
import { DEFAULT_DOCUMENT_PAGE_SIZE } from "constants/document";

export interface CustomDocumentNodeAttrs {
  pageIndex: number;
  pageWidth: number;
  pageHeight: number;
}

export const CustomDocumentNode = Document.extend({
  addAttributes() {
    const attrs: {
      [key in keyof CustomDocumentNodeAttrs]: Attribute;
    } = {
      pageIndex: { default: 0 },
      pageWidth: { default: DEFAULT_DOCUMENT_PAGE_SIZE.width },
      pageHeight: { default: DEFAULT_DOCUMENT_PAGE_SIZE.height },
    };

    return attrs;
  },
});
